import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgServiceLog = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "100%",
	height: "100%",
	viewBox: "0 0 25 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.5 11C15.7121 11 14.9319 11.1552 14.2039 11.4567C13.4759 11.7583 12.8145 12.2002 12.2574 12.7574C11.7002 13.3145 11.2583 13.9759 10.9567 14.7039C10.6552 15.4319 10.5 16.2121 10.5 17C10.5 17.7879 10.6552 18.5681 10.9567 19.2961C11.2583 20.0241 11.7002 20.6855 12.2574 21.2426C12.8145 21.7998 13.4759 22.2417 14.2039 22.5433C14.9319 22.8448 15.7121 23 16.5 23C18.0913 23 19.6174 22.3679 20.7426 21.2426C21.8679 20.1174 22.5 18.5913 22.5 17C22.5 15.4087 21.8679 13.8826 20.7426 12.7574C19.6174 11.6321 18.0913 11 16.5 11ZM15.91 1L20.5 5.59V10.08C19.8726 9.71929 19.2 9.44355 18.5 9.26V6.41L15.09 3H4.5V21H9.58C10.0163 21.75 10.57 22.4252 11.22 23H2.5V1H15.91ZM19.73 13.84L21.14 15.25L15.56 20.85L11.86 17.14L13.27 15.73L15.56 18L19.73 13.84ZM9.58 13C9.21929 13.6274 8.94355 14.3 8.76 15H6.5V13H9.58ZM12.63 10C11.7171 10.5057 10.912 11.1851 10.26 12H6.5V10H12.63ZM13.5 7V9H6.5V7H13.5Z",
		fill: "currentColor"
	})
});
export default SvgServiceLog;
